<mat-table
  [dataSource]="items"
  [trackBy]="trackBy"
  matSort
  matSortDisableClear
  multiTemplateDataRows
  [matSortActive]="sort"
  [matSortDirection]="sortDirection"
  (matSortChange)="onSortChange($event)"
>
  <ng-container matColumnDef="name">
    <mat-header-cell *matHeaderCellDef>{{ 'common.name' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      {{ item.name }}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="provider">
    <mat-header-cell *matHeaderCellDef>{{ 'vehicleIntelligence.hotlist.provider' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span *ngIf="!getCameraIcon(item).hasIcon" class="fs-text-truncate">{{ item.provider }}</span>
      <div class="iconWrapper" *ngIf="getCameraIcon(item).hasIcon">
        <sn-icon
          [matTooltip]="item.type"
          fontSet="fs"
          [fontIcon]="getCameraIcon(item).makeIcon"
        ></sn-icon>
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="heading">
    <mat-header-cell *matHeaderCellDef>{{ 'vehicleIntelligence.heading' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="fs-text-truncate">{{ item.heading }} </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="lastEvent">
    <mat-header-cell *matHeaderCellDef>{{ 'vehicleIntelligence.lastEvent' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="fs-text-truncate">{{ formatDate(item) | fsFormatDate : 'medium' }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef>{{ 'common.actions' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-action-list [items]="actions" [context]="item"></sn-action-list>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="position">
    <mat-cell
      *matCellDef="let item"
      [attr.colspan]="columns.length"
      [class.isExpanded]="isExpanded(item.id)"
    >
      <div class="detail" [@snDetailExpand]="isExpanded(item.id) ? 'expanded' : 'collapsed'">
        <div *ngIf="isExpanded(item.id)">
          <fs-lpr-camera-table-expanded [lprCamera]="item"></fs-lpr-camera-table-expanded>
        </div>
      </div>
    </mat-cell>
  </ng-container>
  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
  <mat-row
    matRipple
    [@snFadeIn]
    [@snFadeOut]
    (click)="toggleExpanded(item)"
    (doubletap)="onItemDblTap(item)"
    *matRowDef="let item; columns: columns"
  >
  </mat-row>
  <mat-row *matRowDef="let row; columns: ['position']" class="detail-row"></mat-row>
</mat-table>
